// Added useRef
import { useCallback, useEffect, useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import "../index.css";
import {
  eventClick,
  eventWithFormInfo,
  fieldErrorEvent,
  formAbandonEvent,
  formIntermediateEventOTP,
  formStarts,
  formSubmissionFailEvent,
  formSubmitEvent,
  submitErrorEvent,
} from "../services/adobeDataLayer.js";

// lsq start

import queryString from "query-string";
import { useCookies } from "react-cookie";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import {
  callLSQLapp,
  encryptBody,
  getFirstNameLastName,
  getLsqLeadBody,
} from "../services/lsq.js";
import { notifySuccess, notifyWarn } from "../services/Toastifyfn";
import {
  formatAndValidateE164,
  hashValue,
  setValuesInLocalStorange,
} from "../services/utils.js";
// lsq end

function Form({ customADL, setCustomADL }) {
  let navigate = useNavigate();
  const [name, setname] = useState("");
  // Added Last name
  const [lastname, setlastname] = useState("");

  const [pan, setpan] = useState("");
  const [pincode, setpincode] = useState("");
  const [mobile, setmobile] = useState("");
  const [branch, setbranch] = useState("");

  const [otp, setotp] = useState("");
  const [checkbox, setcheckbox] = useState("");
  const [showPan, setShowPan] = useState("");

  const [newMargin, setNewMargin] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const SALARY_LANDING_URL =
    "https://campaigns.icici.bank.in/casa/salary/main/index.html";

  const [isSalaried, setIsSalaried] = useState("savings");

  let isValid = 0;

  // SETINPUTS
  const [inputs, setInputs] = useState({
    User_Agent: navigator.userAgent,
    ApiProductName: "Savings Account",
    CampaignId: "832997",
    source: "Landing Page",
    CompleteUrl: window.location.href,
  });

  const [checked, setChecked] = useState(false);
  const [formStarted, setFormStarted] = useState(false);

  // otpstatus 0 - blank otp field
  // otptatus 1 - resend button enabled on otp field
  // otpstatus 2 - timer enabled on otp field
  const [otpstatus, setOtpstatus] = useState(0);

  // Date Chages Start here
  const [date, setDate] = useState(false);
  const [month, setMonth] = useState(false);
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const [dob, setdob] = useState("");
  // End Date Chages

  // lsq integration start
  const [otpsent, setOtpsent] = useState(false);
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [disableBtn, setDistablebtn] = useState(false);
  const [token, setToken] = useState("");
  const [otpdisableBtn, setOtpBtn] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  const [validpincode, setValidincode] = useState(false);
  const [options, setOptions] = useState([
    { Sol_ID: "00", Branch_Name: "Select Branch", AssignLeadToDista: "" },
  ]);
  const [solId, setSolid] = useState("");

  const [timerDisplay, setTimerDisplay] = useState("none");
  const [otpBtnText, setOtpBtnText] = useState("Resend");
  const [resendBtnDisplay, hideDisplayBtn] = useState("initial");
  const [timer, setTimer] = useState(0);
  const [otpDisabled, setOtpDisabled] = useState(false);
  const lastAccessedField = useRef("");

  const [employerName, setEmployerName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [topCorporate, settopCorporate] = useState("");
  const [otherCompanyName, setOtherCompanyName] = useState("")
  const [gcc, setGcc] = useState("");
  const [ppaCode, setPPACode] = useState("");
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [showDropdown, setShowDropdown] = useState(true);
  const { setValue } = useForm();
  const [employerError, setEmployerError] = useState("");
  const [occupation, setOccupation] = useState("");
  const [occupationError, setOccupationError] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [hospitals, setHospitals] = useState([]);
  const [hospitalError, setHospitalError] = useState("");
  const [hospitalGcc, setHospitalGcc] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [colleges, setColleges] = useState([]);
  const [collegeError, setCollegeError] = useState("");
  const [collegeGcc, setCollegeGcc] = useState("");
  // const { register, setValue } = useForm();
  let cancelToken;

  const [occupationData, setOccupationData] = useState({
    occupation: "",
    name: ""
  });

  const [occupationErrors, setOccupationErrors] = useState({
    occupation: "",
    name: ""
  });

  /**
   * Handles changes to the occupation dropdown and occupationName field.
   * Validates input and resets occupation-specific sub-fields when occupation changes.
   * @param {React.ChangeEvent} e - the change event from the select or input
   */
  const handleOccupationChange = (e) => {
    const { name, value } = e.target;

    let cleanedValue = value;

    if (name === "occupationName") {
      cleanedValue = value.replace(/[^a-zA-Z\s]/g, "");

      // Validation for name
      let error = "";

      if (!cleanedValue.trim()) {
        error = "This field is required";
      } else if (cleanedValue.trim().length < 3) {
        error = "Minimum 3 characters required";
      }

      setOccupationErrors((prev) => ({
        ...prev,
        name: error,
      }));
    }

    // Validation for dropdown
    if (name === "occupation") {
      setOccupation(value);
      setOccupationErrors((prev) => ({
        ...prev,
        occupation: value === "" ? "Please select your occupation" : "",
        name: "" // reset name when occupation changes
      }));
      // reset occupation-specific fields when occupation changes
      setEmployerName(""); setGcc(""); setPPACode(""); setCompanies([]);
      setHospitalName(""); setHospitalGcc(""); setHospitals([]);
      setCollegeName(""); setCollegeGcc(""); setColleges([]);
      handleChange(e);
    }

    setOccupationData((prev) => ({
      ...prev,
      [name === "occupationName" ? "name" : name]: cleanedValue,
    }));
  };

  /**
   * Validates occupation fields on blur.
   * Shows an error if the occupation dropdown is empty or occupationName is too short.
   * @param {React.FocusEvent} e - the blur event
   */
  const handleOccupationBlur = (e) => {
    const { name } = e.target;

    if (name === "occupation") {
      if (!occupationData.occupation) {
        setOccupationErrors((prev) => ({
          ...prev,
          occupation: "Please select your occupation",
        }));
      }
    }

    if (name === "occupationName") {
      const value = occupationData.name?.trim();

      let error = "";

      if (!value) {
        error = "This field is required";
      } else if (value.length < 3) {
        error = "Minimum 3 characters required";
      }

      setOccupationErrors((prev) => ({
        ...prev,
        name: error,
      }));
    }
  };

  /**
     * this function is being used for handling the salary selection
     */
  const handleSalariedSelection = (choice) => {
    if (choice === "salary") {
      sessionStorage.setItem("accountType", "savings"); // store current page type

      let utmParams = queryString.parse(window.location.search);

      window.location.assign(
        SALARY_LANDING_URL + "?" + queryString.stringify(utmParams)
      );
      return;
    }

    setIsSalaried("savings");
  };

  /**
   * Reads accountType from sessionStorage on mount to restore the selected account type.
   */
  useEffect(() => {
    const savedType = sessionStorage.getItem("accountType");

    if (savedType === "savings") {
      setIsSalaried("savings");
    } else {
      setIsSalaried("savings"); // default
    }
  }, []);
  /**
   * Memoized callback that decrements the OTP resend timer by 1 each tick.
   */
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  /**
   * Drives the OTP resend countdown timer.
   * Decrements every second while timer > 0 and OTP has been sent for a 10-digit mobile.
   */
  useEffect(() => {
    if (inputs.mobile?.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, inputs.mobile, otpsent]);

  /**
   * Captures Facebook pixel cookies (_fbp, _fbc) on mount.
   * Retries up to 5 times at 4-second intervals if cookies are not yet available.
   */
  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum retries
    const retryInterval = 4000; // Interval between retries in ms

    const getCookieValue = (cookieName) => {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
    };

    const captureCookies = () => {
      const fbpValue = getCookieValue("_fbp") || "";
      const fbcValue = getCookieValue("_fbc") || "";

      setFbp(fbpValue);
      setFbc(fbcValue);

      // Check if retries are needed
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        console.log(retryCount);
        retryCount++;
        setTimeout(captureCookies, retryInterval); // Retry after the interval
      }
    };

    captureCookies(); // Start capturing cookies on mount
  }, []);

  /**
   * Fires a form abandon analytics event when the user navigates away
   * after starting the form (formStarts timestamp is older than the CTA timestamp).
   */
  useEffect(() => {
    // console.log(customADL,"custo,ADL")
    if (customADL.formStarts && customADL.cta) {
      if (customADL.formStarts < customADL.cta) {
        // console.log("formAbandon")
        formAbandonEvent(lastAccessedField.current);
        setCustomADL({ ...customADL, formStarts: "" });
      }
    }
  }, [customADL]);

  /**
   * Debug logger — logs the current lead payload whenever inputs change.
   */
  useEffect(() => {
    // console.log("lead payload", inputs)
  }, [inputs]);

  /**
   * Sets isSalaried to "savings" on the first scroll if it is still empty,
   * ensuring the form becomes visible once the user starts scrolling.
   */
  useEffect(() => {
    const onScroll = () => {
      if (!hasScrolled && isSalaried === "") {
        setHasScrolled(true);
        setIsSalaried("savings");
      }
    };

    window.addEventListener("scroll", onScroll, { once: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hasScrolled, isSalaried]);

  /**
   * Closes any open info tooltips when the user clicks anywhere outside them.
   */
  useEffect(() => {
    const closeTooltip = () => {
      document
        .querySelectorAll(".info-circle.show-tooltip")
        .forEach((el) => el.classList.remove("show-tooltip"));
    };

    document.addEventListener("click", closeTooltip);
    return () => document.removeEventListener("click", closeTooltip);
  }, []);


  /**
   * this useEffect is being used for sending and verifying otp against the mobile number
   */
  useEffect(() => {
    let mobileVal = inputs["mobile"];
    let OTP = inputs["otp"] ? inputs["otp"] : "";
    if (mobileVal !== undefined) {
      if (OTP.length === 6 && mobileVal.length === 10 && token === "") {
        verifyOTPText(mobileVal, OTP);
      }
    }
  }, [token, inputs["otp"], inputs["mobile"]]);

  /**
   * Toggles PAN number visibility between masked (password) and plain text.
   * @param {React.MouseEvent} e - the eye button click event
   */
  const handlePanView = (e) => {
    e.preventDefault();
    setShowPan(!showPan);
  };

  /**
   * Fires an Adobe analytics click event when the Terms & Conditions link is right-clicked.
   * @param {React.MouseEvent} e - the context menu event
   */
  const handleRightCLickTC = (e) => {
    e.preventDefault();
    eventClick("terms and conditions", "link", "form");
  };

  /**
   * Attempts to auto-read the incoming OTP from SMS using the Web OTP API (OTPCredential).
   * Falls back silently if the API is unavailable or the user dismisses the prompt.
   * @param {string} mobile - the mobile number the OTP was sent to
   */
  const mainFun = async (mobile) => {
    if ("OTPCredential" in window) {
      const input = document.querySelector(
        'input[autoComplete="one-time-code"]'
      );
      if (!input) return;
      const ac = new AbortController();
      try {
        const otp = await navigator.credentials.get({
          otp: {
            transport: ["sms"],
          },
          signal: ac.signal,
        });
        input.value = otp.code;
        setInputs((inputs) => ({ ...inputs, otp: otp.code }));
        setTimeout(verifyOTPText(mobile, otp.code), 5000);
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
  };

  /**
   * Sends an OTP to the given mobile number via the LSQ OTP API.
   * Starts the 30-second resend countdown timer on success.
   * @param {string} mobileNumber - 10-digit mobile number starting with 6-9
   * @param {"send"|"resend"} option - whether this is a fresh send or a resend
   */
  const sendOTPText = async (mobileNumber, option) => {
    // let mobileNumber = e.target.value;
    if (
      !mobileNumber ||
      mobileNumber.length !== 10 ||
      !mobileNumber.match(/^[6-9]\d{9}$/)
    ) {
      return;
    }
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "BG", autoReadOtp: "yes" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        setOtpsent(true);
        notifySuccess("OTP has been sent to your mobile number.");
        let otpType = option === "resend" ? "resend" : "send";
        if (option !== "resend") formIntermediateEventOTP(otpType);
        if (option === "resend")
          eventWithFormInfo("resend", "button", "form", "", inputs);

        // setDistablebtn(true);
        setTimerDisplay("inline");
        setTimer(30);
        await mainFun(mobileNumber);
      } else if (
        otpResponse.data.message.response === "MAX OTP Limit reached"
      ) {
        window.alert("OTP Limit reached, try again after 5 minutes");
        window.location.reload();
      } else {
        notifyWarn("Please Resend OTP.");
        setDistablebtn(true);
        setTimerDisplay("inline");
        setTimer(30);
        setOtpsent(false);
      }

      // setMobileval(mobileNumber);
    }
  };

  /**
   * Verifies the entered OTP against the LSQ OTP API.
   * Locks the mobile and OTP fields and enables the submit button on success.
   * @param {string} mobileNum - the mobile number the OTP was sent to
   * @param {string} otpValue - the 6-digit OTP entered by the user
   */
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify", productType: "BG" };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      notifyWarn("Invalid OTP");
      // fieldErrorEvent("invalid otp", "otp");

      let myInputs = { ...inputs };
      // console.log("inputs are", myInputs);
      myInputs.otp = "";
      setInputs(myInputs);
      // setResendBtn(true);
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    inputs.otp = otpValue;
    // setResendBtn(false);
    setDistablebtn(true);
    setOtpBtn(true);
    setBtnDisable(false);
    setTimer(0);
    setOtpDisabled(true);
    hideDisplayBtn("initial");
    setOtpBtnText("Verified");
    formIntermediateEventOTP("verified");

    notifySuccess("OTP Verified Successfully.");
  };

  /**
   * this fn will take pincode and set options for branches to display on UI
   * @param {*} pincode
   */
  async function handleChangePIN(pincode) {
    let PIN = pincode.target.value;
    setInputs((inputs) => ({ ...inputs, ["pincode"]: PIN }));
    if (PIN.length === 6) {
      // console.log("PIN", PIN);
      let payload = { pincode: PIN };
      let param = { type: "SavingsAccountDistaPincode" };
      let response = await callLSQLapp(payload, "MAVIS", param);
      // console.log("response", response);
      if (response.data.message.Count === 0) {
        // console.log("Please enter valid pincode");
        setpincode("Please enter valid pincode");
        setInputs((inputs) => ({
          ...inputs,
          branch: "",
          City: "",
          State: "",
        }));
        setSolid("");
        setValidincode(false);
        setNewMargin(true);
      } else {
        setpincode("");
        setValidincode(true);
        setOptions(response.data.message.Data);
        // set solid and branch
        setInputs((inputs) => ({
          ...inputs,
          branch: response.data.message.Data[0].Branch_Name,
          City: response.data.message.Data[0].City,
          State: response.data.message.Data[0].State,
          // AssigntoDista: response.data.message.Data[0].Assign_o_Dista,
          state2: response.data.message.Data[0].state2,
        }));
        setSolid(response.data.message.Data[0].Sol_ID);
      }
      await checkNegative(pincode);

    }
  }

  
      async function checkNegative(pincode) {
      let PIN = pincode.target.value;
      if (PIN.length === 6) {
        let payload = { pincode: PIN };
        let param = { type: "SavingsAccountNegativePincode" };
        let response = await callLSQLapp(payload, "MAVIS", param);
        const negativePincode =
          response.data.message.Data?.[0]?.Savings_Negative_Pincode ?? "";
        setInputs((inputs) => ({ ...inputs, negativePincode }));
  
      }
    }

  let lastFetchedPrefix = "";

  /**
   * Handles employer name input for the Salaried Professional occupation.
   * Searches for matching companies via MAVIS API with localStorage caching by 4-char prefix.
   * Always appends "Others" to the dropdown list if not already present.
   * @param {React.ChangeEvent} e - the input change event
   */
  const onCompanyChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = searchValue.substring(0, 4).toLowerCase();
    const storageKey = `Savings_company_${prefix}`;

    setEmployerName(inputValue);
    setGcc("");
    setPPACode("");
    handleChange(e);

    const addOthersIfNeeded = (list) => {
      const hasOthers = list.some((item) => item.Company_Name === "Others");
      if (!hasOthers && searchValue.length > 0) {
        return [...list, { Company_Name: "Others", LTF: null }];
      }
      return list;
    };

    const storedData = localStorage.getItem(storageKey);
    const parsedData = storedData ? JSON.parse(storedData) : null;
    // cached entries fetched before PPA_Code support was added won't have the field; treat those as stale so they get refetched
    const isCacheStale =
      parsedData &&
      parsedData.some((item) => item.Company_Name !== "Others" && !("PPA_Code" in item));
    if (isCacheStale) {
      localStorage.removeItem(storageKey);
    }

    if (parsedData && !isCacheStale) {
      const filteredData = parsedData.filter((item) =>
        item.Company_Name.toLowerCase().startsWith(searchValue.toLowerCase())
      );
      const finalData = addOthersIfNeeded(filteredData);
      setCompanies(finalData);
    } else if (searchValue.length >= 3 && prefix !== lastFetchedPrefix) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Cancelled due to new request");
      }

      cancelToken = axios.CancelToken.source();

      try {
        const payload = { company: searchValue };
        const param = { type: "savingsNewGCC" };

        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;

        if (Count > 0) {
          localStorage.setItem(storageKey, JSON.stringify(Data));
          lastFetchedPrefix = prefix;

          const filteredData = Data.filter((item) =>
            item.Company_Name.toLowerCase().startsWith(searchValue.toLowerCase())
          );
          const finalData = addOthersIfNeeded(filteredData);
          setCompanies(finalData);
        } else {
          localStorage.setItem(storageKey, JSON.stringify([]));
          lastFetchedPrefix = prefix;
          setCompanies([{ Company_Name: "Others", LTF: null }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Company fetch failed:", error);
        }
      }
    } else {
      setCompanies([]);
    }

  };



  let lastFetchedHospitalPrefix = "";
  let hospitalCancelToken;

  /**
   * Handles hospital name input for the Doctor occupation.
   * Searches for matching hospitals via MAVIS API with localStorage caching by 4-char prefix.
   * Always appends "Own clinic" and "Others" to the dropdown list.
   * @param {React.ChangeEvent} e - the input change event
   */
  const onHospitalChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = "main_hosp_" + searchValue.substring(0, 4).toLowerCase();

    setHospitalName(inputValue);
    setHospitalGcc("");

    const addHospitalExtras = (list) => {
      const result = list.filter(
        (item) => item.COMPANY_NAME !== "Own clinic" && item.COMPANY_NAME !== "Others"
      );
      return [...result, { COMPANY_NAME: "Own clinic" }, { COMPANY_NAME: "Others" }];
    };

    const storedData = localStorage.getItem(prefix);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filtered = parsedData.filter((item) =>
        item.COMPANY_NAME.toLowerCase().includes(searchValue.toLowerCase())
      );
      setHospitals(addHospitalExtras(filtered));
    } else if (searchValue.length >= 3 && prefix !== lastFetchedHospitalPrefix) {
      if (typeof hospitalCancelToken !== typeof undefined) {
        hospitalCancelToken.cancel("Cancelled due to new request");
      }
      hospitalCancelToken = axios.CancelToken.source();
      try {
        const payload = { company: searchValue };
        const param = { type: "savingsHospital" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;
        if (Count > 0) {
          localStorage.setItem(prefix, JSON.stringify(Data));
          lastFetchedHospitalPrefix = prefix;
          const filtered = Data.filter((item) =>
            item.COMPANY_NAME.toLowerCase().includes(searchValue.toLowerCase())
          );
          setHospitals(addHospitalExtras(filtered));
        } else {
          localStorage.setItem(prefix, JSON.stringify([]));
          lastFetchedHospitalPrefix = prefix;
          setHospitals([{ COMPANY_NAME: "Own clinic" }, { COMPANY_NAME: "Others" }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Hospital fetch failed:", error);
        }
      }
    } else {
      setHospitals([]);
    }
  };

  let lastFetchedCollegePrefix = "";
  let collegeCancelToken;

  /**
   * Handles college name input for the Student occupation.
   * Searches for matching colleges via MAVIS API with localStorage caching by 4-char prefix.
   * Appends "Others" to the dropdown list if not already present.
   * @param {React.ChangeEvent} e - the input change event
   */
  const onCollegeChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = "main_col_" + searchValue.substring(0, 4).toLowerCase();

    setCollegeName(inputValue);
    setCollegeGcc("");

    const addCollegeOthers = (list) => {
      const hasOthers = list.some((item) => item.Institute_Name === "Others");
      if (!hasOthers && list.length > 0) {
        return [...list, { Institute_Name: "Others" }];
      }
      return list;
    };

    const storedData = localStorage.getItem(prefix);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filtered = parsedData.filter((item) =>
        item.Institute_Name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setColleges(addCollegeOthers(filtered));
    } else if (searchValue.length >= 3 && prefix !== lastFetchedCollegePrefix) {
      if (typeof collegeCancelToken !== typeof undefined) {
        collegeCancelToken.cancel("Cancelled due to new request");
      }
      collegeCancelToken = axios.CancelToken.source();
      try {
        const payload = { company: searchValue };
        const param = { type: "savingsCollege" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;
        if (Count > 0) {
          localStorage.setItem(prefix, JSON.stringify(Data));
          lastFetchedCollegePrefix = prefix;
          const filtered = Data.filter((item) =>
            item.Institute_Name.toLowerCase().includes(searchValue.toLowerCase())
          );
          setColleges(addCollegeOthers(filtered));
        } else {
          localStorage.setItem(prefix, JSON.stringify([]));
          lastFetchedCollegePrefix = prefix;
          setColleges([{ Institute_Name: "Others" }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("College fetch failed:", error);
        }
      }
    } else {
      setColleges([]);
    }
  };

  // lsq integration end

  /**
   * Central onChange handler for all form inputs.
   * Fires form-start analytics on first interaction, applies PAN character formatting,
   * resolves Sol ID on branch selection, and handles DOB field auto-focus logic.
   * @param {React.ChangeEvent} event - the input change event
   */
  const handleChange = (event) => {
    setCustomADL({ ...customADL, formStarts: Date.now() });
    if (!formStarted) {
      formStarts();
      setCustomADL({ ...customADL, formStarts: Date.now() });
      setFormStarted(true);
    }

    var name = event.target.name;
    var value = event.target.value;

    if (name === "pan") {
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");

      if (value.length <= 5 && /[^a-zA-Z]/.test(value)) {
        value = value.slice(0, -1);
      }

      if (
        value.length > 5 &&
        value.length <= 9 &&
        /^[^0-9]+$/.test(value.slice(5, 9))
      ) {
        value = value.slice(0, -1);
      }

      if (value.length === 10 && /^[^a-zA-Z]/.test(value.slice(-1))) {
        value = value.slice(0, -1);
      }
    }

    // we are setting solID here against the branchName
    if (name === "branch") {
      const selectedOptionSolid =
        event.target.options[event.target.selectedIndex].getAttribute("solid");
      setSolid(selectedOptionSolid.toString());
    }

    // console.log("name & value", { name, value });

    // dob Changes Start

    // Date validate date and change focus
    if (name === "dob") {
      if (value.length === 2 && value === "00") {
        value = "";
        setDate(value);
      }
      if (value.length === 1 && value >= 1 && value <= 3) {
        setDate(value);
      } else if (value.length === 1 && value >= 4 && value <= 9) {
        setDate("0" + value);
        monthRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 31) {
        setDate(value);
        monthRef.current.focus();
      } else if (value >= 32) {
        setDate(value.slice(0, 1));
      } else {
        setDate(value);
        // console.log(date)
      }
    }

    // // Month validate date and change focus
    if (name === "dob_month") {
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        if (value === 2 && date >= 30) {
          setDate("");
          dayRef.current.focus();
        } else {
          yearRef.current.focus();
        }
        setMonth("0" + value);
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
        // console.log(month)
      }
    }

    // // Year validate date and change focus
    if (name === "dob_month") {
      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }
      if (value.length === 2 && value === "00") {
        value = "";
        setMonth(value);
      }
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        setMonth("0" + value);
        yearRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
      }
    }

    if (name === "dob_year") {
      if (value.length === 1) {
        if (value !== "1" && value !== "2") {
          value = "";
        }
      }

      if (value.length === 2) {
        if (value !== "19" && value !== "20") {
          value = value.slice(0, -1);
        }
      }
      // MAX AGE
      let yearStart = new Date().getFullYear() - 70;
      var year = new Date().getFullYear();

      if (value.length === 4 && value < yearStart) {
        value = value.slice(0, -1);
      }

      if (value.length === 4 && value > year) {
        value = value.slice(0, -1);
      }

      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }

      if (month >= 1 && month <= 9 && month.length === 1) {
        setMonth("0" + month);
      }
    }
    // dob Changes End

    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  /**
   * Validates each field on blur and sets the corresponding error message state.
   * Covers name, mobile, PAN, occupation, employer, hospital, college, pincode, OTP, branch, and DOB.
   * @param {React.FocusEvent} event - the blur event
   */
  const handleBlur = (event) => {
    const name = event.target.name;
    lastAccessedField.current = name;
    const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

    const name_reg = /^[a-zA-Z ]*$/;
    const short_name_reg = /^([a-zA-Z]\s[a-zA-Z]{1,2}|[a-zA-Z]{2}\s[a-zA-Z])$/;

    if (name === "name") {
      const trimmedName = inputs.name ? inputs.name.trim() : "";
      if (
        inputs.name === "" ||
        inputs.name === undefined ||
        trimmedName.length <= 2
      ) {
        setname("Please enter your full name.");
        fieldErrorEvent("Please enter your full name.", "name");
        isValid++;
      } else {
        if (!inputs.name.match(name_reg) || short_name_reg.test(trimmedName)) {
          setname("Please enter valid full name.");
          fieldErrorEvent("Please enter valid full name.", "name");

          isValid++;
        } else {
          setname("");
        }
      }
    }

    // Last name validaton
    // if (name === "lastname") {
    //   if (inputs.lastname === "" || inputs.lastname === undefined) {
    //     setlastname("Please enter your last name.");
    //     setNewMargin(true);
    //     isValid++;
    //   } else {
    //     if (inputs.lastname.trim().length < 1) {
    //       setlastname("Please enter valid last name.");
    //       setNewMargin(true);
    //       isValid++;
    //     } else if (!inputs.lastname.match(lastname_reg)) {
    //       setlastname("Please enter valid last name.");
    //       setNewMargin(true);
    //       isValid++;
    //     } else {
    //       setlastname("");
    //     }
    //   }
    // }

    if (name === "mobile") {
      if (!inputs.mobile) {
        setmobile("Please enter your mobile number.");
        fieldErrorEvent("Please enter your mobile number.", "mobile");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.mobile.match(mobile_reg) || /^(\d)\1{9}$/.test(inputs.mobile) || /^(\d{2})\1{4}$/.test(inputs.mobile)) {
          setmobile("Please enter valid mobile number.");
          fieldErrorEvent("Please enter valid mobile number.", "mobile");

          setNewMargin(true);
          isValid++;
        } else {
          setmobile("");
        }
      }
    }

    if (name === "pan") {
      if (!inputs.pan) {
        setpan("Please enter your pan number.");
        fieldErrorEvent("Please enter your pan number.", "pan");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.pan.match(regpan)) {
          setpan("Please enter valid pan number.");
          fieldErrorEvent("Please enter valid pan number.", "pan");
          setNewMargin(true);
          isValid++;
        } else {
          setpan("");
        }
      }
    }

    if (name === "occupation") {
      if (!occupation || occupation === "") {
        setOccupationError("Please select your occupation.");
        fieldErrorEvent("Please select your occupation.", "occupation");
        isValid++;
      } else {
        setOccupationError("");
      }
    }

    if (name === "employer_name" && occupation === "Salaried Professional") {
      if (!employerName || employerName.trim() === "") {
        setEmployerError(" Please enter your employer name");
        fieldErrorEvent("Please enter your employer name", "employer_name");
        isValid++;
      } else {
        if (!gcc) {
          setEmployerName("Others");
          setGcc("Others");
        }
        setEmployerError("");
      }
    }

    if (name === "hospital_name" && occupation === "Doctor") {
      if (!hospitalName || hospitalName.trim() === "") {
        setHospitalError(" Please enter your hospital name.");
        fieldErrorEvent("Please enter your hospital name.", "hospital_name");
        isValid++;
      } else {
        setHospitalError("");
      }
    }

    if (name === "college_name" && occupation === "Student") {
      if (!collegeName || collegeName.trim() === "") {
        setCollegeError(" Please enter your college name.");
        fieldErrorEvent("Please enter your college name.", "college_name");
        isValid++;
      } else {
        if (!collegeGcc) {
          setCollegeName("Others");
          setCollegeGcc("Others");
        }
        setCollegeError("");
      }
    }

    if (name === "pincode") {
      var pincode_reg = /^[1-9][0-9]{5}$/;
      if (!inputs.pincode) {
        setpincode("Please enter valid pincode.");
        fieldErrorEvent("Please enter valid pincode.", "pincode");
        setNewMargin(true);
        isValid++;
      } else {
        // console.log("validpincode", validpincode);
        if (!inputs.pincode.match(pincode_reg) || !validpincode) {
          setpincode("Please enter valid pincode.");
          fieldErrorEvent("Please enter valid pincode.", "pincode");
          setNewMargin(true);
          isValid++;
        } else {
          // console.log("clearing this");
          setpincode("");
        }
      }
    }

    if (name === "otp") {
      var otp_reg = /^[0-9]{6}$/;
      if (!inputs.otp) {
        setotp("Please enter valid otp.");
        fieldErrorEvent("Please enter valid otp.", "otp");
        setNewMargin(true);
        isValid++;
      } else {
        if (!inputs.otp.match(otp_reg)) {
          setotp("Please enter valid otp number.");
          fieldErrorEvent("Please enter valid otp number.", "otp");
          setNewMargin(true);
          isValid++;
        } else {
          setotp("");
        }
      }
    }

    if (name === "branch") {
      if (!inputs.branch) {
        setbranch("Please select branch.");
        fieldErrorEvent("Please select branch.", "branch");
        setNewMargin(true);
        isValid++;
      }

      if (validpincode && inputs.branch) {
        setbranch("");
      }
    }

    // dob Changes Start

    if (name === "dob" || name === "dob_month" || name === "dob_year") {
      var year = new Date().getFullYear();
      var yearStart = new Date().getFullYear() - 110;
      var dob_error = false;
      if (
        name === "dob" &&
        inputs.dob !== "undefined" &&
        !(inputs.dob >= 1 && inputs.dob <= 31)
      ) {
        isValid++;
        dob_error = true;
        setdob("Please enter valid Date Of Birth.");
        fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
      } else {
        dob_error = false;

        setdob("");
      }

      if (name === "dob_month" && !dob_error) {
        if (
          typeof inputs.dob_month !== "undefined" &&
          !(inputs.dob_month >= 1 && inputs.dob_month <= 12)
        ) {
          isValid++;
          dob_error = true;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else {
          dob_error = false;
          setdob("");
        }
      }

      if (name === "dob_year" && !dob_error) {
        if (!inputs.dob_year) {
          isValid++;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else if (
          (typeof inputs.dob_year !== "undefined" &&
            inputs.dob_year < yearStart) ||
          inputs.dob_year >= year
        ) {
          isValid++;
          setdob("Please enter valid Date Of Birth.");
          fieldErrorEvent("Please enter valid Date Of Birth.", "dob");
        } else {
          setdob("");
        }
      }
    }
    // dob Changes End
  };

  const errorRef = useRef({});

  /**
   * Handles form submission — validates all fields, builds the lead payload,
   * encrypts it, creates the LSQ lead, and navigates to the thank-you page on success.
   * @param {React.FormEvent} event - the form submit event
   */
  const handleSubmit = async (event) => {

    event.preventDefault();
    const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    const name_reg = /^[a-zA-Z ]*$/;
    const short_name_reg = /^([a-zA-Z]\s[a-zA-Z]{1,2}|[a-zA-Z]{2}\s[a-zA-Z])$/;

    const trimmedName = inputs.name ? inputs.name.trim() : "";
    if (
      inputs.name === "" ||
      inputs.name === undefined ||
      trimmedName.length <= 2
    ) {
      setname("Please enter your full name");
      errorRef.current.name = "Please enter your full name";
      isValid++;
    } else {
      if (!inputs.name.match(name_reg) || short_name_reg.test(trimmedName)) {
        setname("Please enter valid full name");
        errorRef.current.name = "Please enter valid full name";

        isValid++;
      } else {
        setname("");
      }
    }

    if (!inputs.branch && validpincode) {
      setbranch("Please select branch.");
      errorRef.current.branch = "Please select branch.";

      setNewMargin(true);
      isValid++;
    }

    if (!inputs.mobile) {
      setmobile("Please enter your mobile number.");
      errorRef.current.number = "Please enter your mobile number.";
      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.mobile.match(mobile_reg)) {
        setmobile("Please enter valid mobile number.");
        errorRef.current.number = "Please enter valid mobile number.";

        isValid++;
      } else {
        setmobile("");
      }
    }

    var otp_reg = /^[0-9]{6}$/;
    if (!inputs.otp) {
      setotp("Please enter valid otp.");
      errorRef.current.otp = "Please enter valid otp.";
      isValid++;
    } else {
      if (!inputs.otp.match(otp_reg)) {
        setotp("Please enter valid otp number.");
        errorRef.current.otp = "Please enter valid otp.";

        isValid++;
      } else {
        setotp("");
      }
    }

    if (!inputs.pan) {
      setpan("Please enter your pan number.");
      errorRef.current.pan = "Please enter your pan number.";
      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.pan.match(regpan)) {
        setpan("Please enter valid pan number.");
        errorRef.current.pan = "Please enter valid pan number.";
        isValid++;
      } else {
        setpan("");
      }
    }

    var pincode_reg = /^[1-9][0-9]{5}$/;
    if (!inputs.pincode) {
      setpincode("Please enter valid pincode.");
      errorRef.current.pincode = "Please enter valid pincode.";

      setNewMargin(true);
      isValid++;
    } else {
      if (!inputs.pincode.match(pincode_reg) || !validpincode) {
        setpincode("Please enter valid pincode.");
        errorRef.current.pincode = "Please enter valid pincode.";
        isValid++;
      } else {
        setpincode("");
      }
    }
    if (checked === false) {
      setcheckbox(
        "Please accept our terms and conditions by clicking on the checkbox."
      );
      errorRef.current.checkbox =
        "Please accept our terms and conditions by clicking on the checkbox.";

      setNewMargin(true);
      isValid++;
    } else {
      setcheckbox("");
    }

    if (!occupation || occupation === "") {
      setOccupationErrors((prev) => ({ ...prev, occupation: "Please select your occupation." }));
      errorRef.current.occupation = "Please select your occupation.";
      isValid++;
    } else {
      setOccupationErrors((prev) => ({ ...prev, occupation: "" }));
    }

    if (occupation === "Salaried Professional") {
      if (!employerName || employerName.trim() === "") {
        setEmployerError(" Please enter your employer name.");
        errorRef.current.employer = " Please enter your employer name.";
        isValid++;
      } else {
        setEmployerError("");
      }
    }

    if (occupation === "Doctor") {
      if (!hospitalName || hospitalName.trim() === "") {
        setHospitalError(" Please enter your hospital name.");
        errorRef.current.hospitalName = " Please enter your hospital name.";
        isValid++;
      } else {
        setHospitalError("");
      }
    }

    if (occupation === "Student") {
      if (!collegeName || collegeName.trim() === "") {
        setCollegeError(" Please enter your college name.");
        errorRef.current.collegeName = " Please enter your college name.";
        isValid++;
      } else {
        setCollegeError("");
      }
    }

    if (isValid === 0) {
      // console.log("form input values", inputs);
      // notifyWarn("This may take upto 15 seconds. Please do not reload the page!")
      setApplyBtnDisable(true);

      // GET UTM DETAILS
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        inputs[key] = value;
      }
      // dob in YYYY-MM-DD format
      // let DateOfBirthValue = `${inputs.dob_year}-${inputs.dob_month.padStart(2, 0)}-${inputs.dob.padStart(2, 0)}`;

      // constants value
      // inputs.DateOfBirthValue = DateOfBirthValue

      // setInputs({
      //   ...inputs,
      //   token: token,
      //   solId: solId,
      //   isChecked: checked,
      //   FBPixelID: fbp,
      //   FBClickID: fbc,
      //   firstname: firstName,
      //   lastname: lastName,
      // });
      const { firstName, lastName } = getFirstNameLastName(inputs.name);

      const payloadInputs = {
        ...inputs,
        token: token,
        solId: solId,
        isChecked: checked,
        FBPixelID: fbp,
        FBClickID: fbc,
        firstname: firstName,
        lastname: lastName,
      };

      payloadInputs.occupation = occupation;
      if (occupation === "Salaried Professional") {
        payloadInputs.companyName = employerName || "";
        payloadInputs.gcc = employerName?.toLowerCase() === "others" ? "Others" : gcc || "";
        payloadInputs.ppaCode = employerName?.toLowerCase() === "others" ? "Others" : ppaCode || "";
        payloadInputs.otherCompany = "";
      } else if (occupation === "Doctor") {
        payloadInputs.companyName = hospitalName || "";
        payloadInputs.gcc = hospitalGcc || "";
      } else if (occupation === "Student") {
        payloadInputs.companyName = collegeName || "";
        payloadInputs.gcc = collegeGcc || "";
      }
      let lsqInputs = getLsqLeadBody(payloadInputs);
      let payload = {
        mobile: payloadInputs.mobile,
        otp: payloadInputs.otp,
        formdata: lsqInputs,
      };
      let param = { productType: "BG" };
      // console.log("final input values", lsqInputs);
      // Encrypt Payloads
      const encryptedPayload = await encryptBody(payload);
      const createLeadResp = await callLSQLapp(
        encryptedPayload,
        "CREATE",
        param
      );

      // ? IF Lead Created
      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        if (inputs.mobile) {
          const formattedMobile = formatAndValidateE164(inputs.mobile);
          const hashedMobile = await hashValue(formattedMobile);
          setValuesInLocalStorange("userData", "", hashedMobile);
          console.log(localStorage.getItem("userData"), "userData");
        }

        console.log("navigate to thankyou");
        formSubmitEvent(inputs, true);
        navigate(`/thankyou?id=${leadid}`);
      } else {
        setApplyBtnDisable(false);
        console.log("lead not created.");
        formSubmissionFailEvent();
        console.log(window.adobeDataLayer || []);
        window.alert("Some error occured! Please try again after some time.");
        // window.location.reload();
      }
      // navigate("/thankyou");
    } else {
      isValid = 0;
      setNewMargin(true);
      submitErrorEvent(errorRef.current);
      return false;
    }
  };

  return (

    <div className="form_wrap" id="saving_account">
      <div className="form_heading">
        <h4>
          Open your bank account in few clicks
        </h4>
      </div>



      {/* ================= MAIN FORM ================= */}
      {isSalaried === "savings" && (
        <form name="contactForm" method="post" onSubmit={handleSubmit} className="contact-form">
          <section className="personal-details">
            <div className="col-12 my-3">
              <p className="form_lead_text">
                Which type of account would you like to open?
              </p>

              <div className="form_buttons">
                <label>
                  <input
                    type="radio"
                    name="accountType"
                    checked={isSalaried === "savings"}
                    onChange={() => handleSalariedSelection("savings")}
                  />
                  <b>Savings Account</b>
                </label>
                <label className="information">
                  <input
                    type="radio"
                    name="accountType"
                    checked={isSalaried === "salary"}
                    onChange={() => handleSalariedSelection("salary")}
                  />
                  <b>Salary Account

                    <span
                      className="info-circle"
                      onClick={(e) => {
                        e.preventDefault();   // THIS STOPS LABEL - CHECKBOX
                        e.stopPropagation(); // THIS STOPS EVENT BUBBLING
                        e.currentTarget.classList.toggle("show-tooltip");
                      }}

                    >
                      <img src="dist/img/info.svg" className="info" alt="info" width={22} height={22} />
                      <span className="tooltip-box">
                        <strong>Account for Salaried Professionals</strong>
                        <ul>
                          <li>• For monthly salary credit</li>
                          <li>• No minimum balance required</li>
                          <li>• Unlimited ATM transactions</li>
                        </ul>
                      </span>
                    </span>


                  </b>


                </label>


              </div>
            </div>

            {/* =========== first name and last name start =============*/}



            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 input_wrapper">
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Full Name (As per PAN)"
                    id="name"
                    value={
                      inputs.name
                        ? inputs.name.replace(/[^a-z ]/gi, "")
                        : ""
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={(e) =>
                    (e.target.value = e.target.value.replace(
                      /[^a-zA-Z\s]/gi,
                      ""
                    ))
                    }
                    className={name !== "" ? "errBrdr" : ""}
                  />

                </div>
                {name !== "" ? (
                  <span className="error-msg">
                    {name}
                  </span>
                ) : null}
              </div>
            </div>

            {/* =========== date of birth field end =========== */}
            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 input_wrapper">
                  <input
                    type={`${showPan ? "text" : "password"}`}
                    name="pan"
                    placeholder="PAN No."
                    id="pan"
                    value={inputs.pan ? inputs.pan : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                  />
                  <button
                    onClick={handlePanView}
                    aria-label="Eye"
                    className="show-pan"
                  >
                    <FaEye />
                  </button>
                </div>
                {pan !== "" ? (
                  <span className="error-msg">
                    {pan}
                  </span>
                ) : null}

              </div>
            </div>

            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 input_wrapper autocomplete">
                  <input
                    className=""
                    type="number"
                    min="0"
                    placeholder="PIN Code of your current address"
                    id="pincode"
                    name="pincode"
                    value={
                      inputs.pincode > 0
                        ? inputs.pincode.replace(/^0+/, "")
                        : ""
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 6))
                    }
                    onChange={handleChangePIN}
                    onBlur={handleBlur}
                  />
                </div>
                {pincode !== "" ? (
                  <span className="error-msg">
                    {pincode}
                  </span>
                ) : null}

              </div>
            </div>


            <div className="col-12 my-2"
              style={{
                display:
                  inputs["pincode"]?.length === 6 &&
                    pincode === "" &&
                    validpincode
                    ? "block"
                    : "none",
              }}
            >
              <div className="row">
                <div className="col-12 input_wrapper"

                >
                  <select
                    aria-label="Branch Name"
                    className="select_box"
                    name="branch"
                    id="branch"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    {options.map((option) => (
                      <option
                        key={option.Sol_ID}
                        value={option.Branch_Name}
                        solid={option.Sol_ID}
                        data-assign-lead-to-dista={option.AssignLeadToDista}
                      >
                        {option.Branch_Name}
                      </option>
                    ))}
                  </select>
                </div>

                {branch !== "" ? (
                  <span className="error-msg">
                    {branch}
                  </span>
                ) : null}

              </div>
            </div>



            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 input_wrapper">
                  <select
                    aria-label="Occupation"
                    name="occupation"
                    id="occupation"
                    className="select_box"
                    value={occupationData.occupation}
                    onChange={handleOccupationChange}
                    onBlur={handleOccupationBlur}

                  >
                    <option value="" disabled>Select your occupation</option>
                    <option value="Salaried Professional">Salaried Professional</option>
                    <option value="Doctor">Doctor</option>
                    <option value="Student">Student</option>
                    <option value="Chartered Accountant">Chartered Accountant</option>
                    <option value="Business owner/Self-employed">Business owner/Self-employed</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
                {occupationErrors.occupation && (
                  <span className="error-msg">
                    {occupationErrors.occupation}
                  </span>
                )}
              </div>
            </div>



            {/* =========== Employer name (Salaried Professional only) =========== */}
            {occupation === "Salaried Professional" && (
              <div className="col-12 my-2">
                <div className="input_wrapper">
                  <input
                    type="text"
                    name="employer_name"
                    placeholder="Enter your employer name"
                    id="employer_name"
                    value={employerName}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      onCompanyChange(e);
                      handleChange(e);
                    }}
                    className={employerError !== "" ? "errBrdr" : ""}
                  />
                  {showDropdown && companies.length > 0 && (
                    <ul className="company-dropdown">
                      {companies.map((item) => (
                        <li
                          className="company-List"
                          key={item.Company_Name}
                          onClick={() => {
                            if (item.Company_Name === "Others") {
                              setEmployerName("Others");
                              setGcc("Others");
                              setPPACode("Others");
                            } else {
                              setEmployerName(item.Company_Name);
                              setGcc(item.GCC);
                              setPPACode(item.PPA_Code);
                            }
                            setCompanies([]);
                            setEmployerError("");
                            setValue("companyName", item.Company_Name);
                          }}
                        >
                          {item.Company_Name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {employerError !== "" && (
                  <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontWeight: 400, color: "red" }}>
                    {employerError}
                  </span>
                )}
              </div>
            )}

            {/* =========== Hospital name (Doctor only) =========== */}
            {occupation === "Doctor" && (
              <div className="col-12 my-2">
                <div className="input_wrapper">
                  <input
                    type="text"
                    name="hospital_name"
                    placeholder="Enter hospital name"
                    id="hospital_name"
                    value={hospitalName}
                    onBlur={handleBlur}
                    onChange={onHospitalChange}
                    className={hospitalError !== "" ? "errBrdr" : ""}
                  />
                  {hospitals.length > 0 && (
                    <ul className="company-dropdown">
                      {hospitals.map((item) => (
                        <li
                          className="company-List"
                          key={item.COMPANY_NAME}
                          onClick={() => {
                            setHospitalName(item.COMPANY_NAME);
                            setHospitals([]);
                            setHospitalError("");
                            const isOther = item.COMPANY_NAME === "Own clinic" || item.COMPANY_NAME === "Others";
                            setHospitalGcc(isOther ? "Others" : "GCC");
                          }}
                        >
                          {item.COMPANY_NAME}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {hospitalError !== "" && (
                  <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontWeight: 400, color: "red" }}>
                    {hospitalError}
                  </span>
                )}
              </div>
            )}

            {/* =========== College name (Student only) =========== */}
            {occupation === "Student" && (
              <div className="col-12 my-2">
                <div className="input_wrapper">
                  <input
                    type="text"
                    name="college_name"
                    placeholder="Enter college name"
                    id="college_name"
                    value={collegeName}
                    onBlur={handleBlur}
                    onChange={onCollegeChange}
                    className={collegeError !== "" ? "errBrdr" : ""}
                  />
                  {colleges.length > 0 && (
                    <ul className="company-dropdown">
                      {colleges.map((item) => (
                        <li
                          className="company-List"
                          key={item.Institute_Name}
                          onClick={() => {
                            setCollegeName(item.Institute_Name);
                            setColleges([]);
                            setCollegeError("");
                            setCollegeGcc(item.Institute_Name === "Others" ? "Others" : "GCC");
                          }}
                        >
                          {item.Institute_Name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {collegeError !== "" && (
                  <span style={{ fontSize: "12px", fontFamily: "sans-serif", fontWeight: 400, color: "red" }}>
                    {collegeError}
                  </span>
                )}
              </div>
            )}
            {/* 
            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 input_wrapper">

                  <input
                    type="text"
                    name="employer_name"
                    placeholder="Enter your company name"
                    id="employer_name"
                    value={employerName}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      onCompanyChange(e);
                      handleChange(e)
                    }}
                  />

                  {showDropdown && companies.length > 0 && (
                    <ul className="company-dropdown">
                      {companies.map((item) => (
                        <li
                          className="company-List"
                          key={item.Company_Name}
                          onClick={() => {
                            if (item.Company_Name === "Others") {
                              setShowOtherInput(true);
                              setEmployerName("Others");
                              setValue("annualIncome", "")
                              clearErrors("annualIncome");
                              setOtherCompanyName("");
                              setValue("otherCompanyName", "");
                              clearErrors("otherCompanyName");
                            } else {
                              setEmployerName(item.Company_Name);
                              setGcc(item.GCC)
                              setShowOtherInput(false);
                            }
                            setCompanies([]);
                            setValue("companyName", item.Company_Name);
                          }}
                        >
                          {item.Company_Name}
                        </li>
                      ))}
                    </ul>
                  )}

                </div>
              </div>
            </div>

            {showOtherInput && (
              <>
                <div className="col-12 my-2">
                  <div className="row">
                    <div className="col-12 my-2 input_wrapper">
                      <input
                        className="input-box"
                        type="text"
                        name="OtherCompany"
                        id="OtherCompany"
                        placeholder="Enter Other Company Name"
                        value={otherCompanyName}
                        onChange={(e) => {
                          setOtherCompanyName(e.target.value)
                        }}

                      />
                    </div>

                  </div>
                </div>

              </>
            )}
 */}
            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 input_wrapper">

                  <span className=" number-span ">+91 </span>
                  <input
                    readOnly={disableBtn}
                    type="number"
                    name="mobile"
                    placeholder="Mobile number"
                    value={
                      inputs.mobile > 0
                        ? inputs.mobile.replace(/^[0-5]+/, "")
                        : ""
                    }
                    pattern="\d{10}"
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                      if (val.length > 0 && !/^[6-9]/.test(val)) {
                        setmobile("Please enter valid mobile number.");
                      } else if (val.length === 10 && (/^(\d)\1{9}$/.test(val) || /^(\d{2})\1{4}$/.test(val))) {
                        setmobile("Please enter valid mobile number.");
                      } else {
                        setmobile("");
                      }
                    }}
                    id="mobile_number"
                    style={{ textAlign: "left" }}
                    className={mobile !== "" ? "errBrdr" : "errBrdr"}
                    onWheel={(e) => e.target.blur()}
                  />

                  {!otpsent && (
                    <button
                      type="button"
                      className="btn"
                      id="resendBtn"
                      onClick={() => sendOTPText(inputs.mobile, "send")}
                      style={{ display: resendBtnDisplay }}
                      disabled={otpDisabled || !(
                        /^[6-9]\d{9}$/.test(inputs.mobile) &&
                        !/^(\d)\1{9}$/.test(inputs.mobile) &&
                        !/^(\d{2})\1{4}$/.test(inputs.mobile)
                      )}
                    >
                      Send OTP
                    </button>
                  )}

                  {inputs.mobile?.length === 10 && otpsent && timer <= 0 ? (
                    <button
                      type="button"
                      className="btn"
                      id="resendBtn"
                      onClick={() => sendOTPText(inputs.mobile, "resend")}
                      style={{ display: resendBtnDisplay }}
                      disabled={otpDisabled}
                    >
                      {otpBtnText}
                    </button>
                  ) : (
                    <span
                      className="Timer"
                      id="timer"
                      style={{ display: timerDisplay }}
                    >
                      {" "}
                      00:
                      {timer.toString().length < 2
                        ? timer.toString().padStart(2, "00")
                        : timer}
                    </span>
                  )}
                </div>
                {mobile !== "" ? (
                  <span className="error-msg">
                    {mobile}
                  </span>
                ) : null}

              </div>
            </div>


            {/* Css Class added for full length blank otp field  */}

            <div className="col-12 my-2">
              <div className="row">
                <div
                  className={
                    otpstatus === 0
                      ? "col-12 align-items-center w-100 mt-1 input_wrapper"
                      : "col-12 d-flex align-items-center w-75 mt-1 input_wrapper"
                  }
                >
                  <input
                    autoComplete="one-time-code"
                    value={inputs["otp"] ? inputs["otp"] : ""}
                    readOnly={disableBtn}
                    type="number"
                    min="0"
                    name="otp"
                    pattern="\d{6}"
                    placeholder="OTP"
                    id="otp"
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 6))
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {/* =========== timer and resend button start =============*/}
                  {otpstatus === 2 ? (
                    <div className="timer_wrapper text-center ms-1">
                      <span id="timer">00:00</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {otpstatus === 1 ? (
                    <div className="resend_btn ms-1">
                      <button>Resend</button>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* =========== timer and resend button end =============*/}
                </div>
                {otp !== "" ? (
                  <span className="error-msg">
                    {otp}
                  </span>
                ) : null}
                <p style={{ color: "#E3541F", fontSize: "12px", marginTop: "8px", marginBottom: "8px" }}>
                  <strong>Note:</strong> Minimum balance requirement applicable as per account type.
                </p>

              </div>
            </div>

            <div className="col-12 my-2">
              <div className="row">
                <div className="col-12 checkbox check-input">
                  <input
                    type="checkbox"
                    name="checkbox"
                    onChange={handleChange}
                    defaultChecked={checked}
                    onClick={() => {
                      setChecked(!checked);
                      eventWithFormInfo(
                        "terms & conditions",
                        "checkbox",
                        "form",
                        "",
                        inputs
                      );
                    }}
                    id="checkbox"
                  />
                  <label htmlFor="checkbox">
                    I consent to be contacted by ICICI Bank
                    regarding this product via Call/ SMS/ Email/
                    WhatsApp/ RCS. I accept ICICI Bank’s{" "}
                    <a
                      href="https://www.icici.bank.in/content/dam/icicibank/india/managed-assets/docs/terms-condition/tnc-savings-account.pdf?ITM=nli_termsConditions_termsConditions_na_na_11_na_na_NLI"
                      onClick={() => {
                        eventWithFormInfo(
                          "terms & conditions",
                          "link",
                          "form"
                        );
                      }}
                      onContextMenu={handleRightCLickTC}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Terms & Conditions
                    </a>
                    .
                  </label>
                </div>
                {checkbox !== "" ? (
                  <span
                    className="error-msg"
                    style={{ fontFamily: "Mulish, sans-serif", fontWeight: 600 }}
                  >
                    {checkbox}
                  </span>
                ) : null}

              </div>
            </div>



            <div className="applynow">
              <button
                disabled={disableApplyBtn}
                type="submit"
                style={{
                  backgroundColor: disableApplyBtn ? "grey" : "",
                }}
              >
                {disableApplyBtn ? "Submitting..." : "Apply Now"}
              </button>


            </div>
          </section>
        </form>
      )}
      <ToastContainer />
    </div>
  );
}

export default Form;
